import React, { useState, useEffect, useContext } from "react";
import { Button, Card, Skeleton, Tooltip } from "antd";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import { SettingContext } from "../../routes";
import CustomTable from "../common/Table";
import { useQuery } from "react-query";
import { decrypt, formatDate } from "../../services/util";
import { useParams, useSearchParams } from "react-router-dom";

function HotelDashboardTickets() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const { type } = useParams();
    const [search] = useSearchParams();
    const hotel_id = decrypt(`${search.get("id").replace("plus", "+")}`);
    const { selectedDates } = useContext(SettingContext);
    const [supportData, setSupportData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    const [start_date, end_date] = selectedDates;

    const [formData, setFormData] = useState({
        staff_id,
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        data_for: type,
        hotel_id,
    });

    const columns = [
        {
            title: "Key",
            key: "ticket_key",
            render: (text, record) => {
                return (
                    <a href={record.link} target="_blank" rel="noreferrer">
                        {record.ticket_key}
                    </a>
                );
            },
        },

        {
            title: "Hotel",
            dataIndex: "hotel_name",
            key: "hotel_name",
            sorter: () => {},
            width: 200,
        },
        {
            title: "Component",
            dataIndex: "component_name",
            key: "component_name",
            sorter: () => {},
        },
        {
            title: "Date",
            dataIndex: "created_at",
            key: "created_at",
            sorter: () => {},
        },
        {
            title: "Summary",
            dataIndex: "summary",
            key: "summary",
            sorter: () => {},
            width: 200,
        },
        {
            title: "Type",
            dataIndex: "issue_type",
            key: "issue_type",
            sorter: () => {},
        },
        {
            title: "Priority",
            dataIndex: "priority",
            key: "priority",
            sorter: () => {},
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            sorter: () => {},
        },
        {
            title: "Comments",
            render: (_, record) => {
                return record.comments?.length > 0 ? (
                    <ul>
                        {record.comments.map(({ comment_id, comment }) => (
                            <li key={comment_id}>
                                <Tooltip placement="rightTop" title={comment}>
                                    <span>
                                        {comment.length <= 30
                                            ? comment
                                            : `${comment.substring(0, 30)}...`}
                                    </span>
                                </Tooltip>
                            </li>
                        ))}
                    </ul>
                ) : null;
            },
            sorter: () => {},
            width: 250,
        },

        {
            title: "Reported By",
            dataIndex: "reporter_name",
            key: "reporter_name",
            sorter: () => {},
        },
        {
            title: "Assigned To",
            dataIndex: "assignee_name",
            key: "assignee_name",
            sorter: () => {},
        },
        {
            title: "Update Status",
            render: (text, record) => {
                return (
                    <Button
                        type="primary"
                        onClick={() => showUpdateModal(record.ticket_key)}
                    >
                        Update Status
                    </Button>
                );
            },
        },
        {
            title: "Attachements",
            render: (text, record) => {
                return (
                    <Button
                        type="primary"
                        onClick={() => showAttachModal(record.ticket_key)}
                    >
                        Upload Attachment
                    </Button>
                );
            },
        },
    ];

    const {
        status: detailStatus,
        data: detailRes,
        refetch: fetchDetails,
    } = useQuery(
        type,
        async () => {
            return await HTTP("/hotels/getSingleHotelDashboardTicketsList", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchDetails();
    }, []);

    useEffect(() => {
        fetchDetails();
    }, [formData]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
            page: 0,
        });
    }, [selectedDates]);

    useEffect(() => {
        if (detailStatus === "success") {
            const { data, total } = detailRes;
            setSupportData(data);
            setTotalRecords(total);
        }
    }, [detailStatus, detailRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }

        const newFormData = {
            ...formData,
            ...others,
        };
        setFormData(newFormData);
        setCurrentPage(current);
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            <Card className="box-shadow margin-10">
                {detailStatus == "loading" || detailStatus == "idle" ? (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                ) : (
                    <CustomTable
                        columns={columns}
                        tableData={supportData}
                        currentPage={currentPage}
                        noOfrecords={totalRecords}
                        handleTableChange={handleTableChange}
                        rowKey="hotel_id"
                        className="dashboard-table"
                    />
                )}
            </Card>
        </Card>
    );
}

export { HotelDashboardTickets };
